// extracted by mini-css-extract-plugin
export default {"label":"Label_label__A+3Wc","required":"Label_required__hxoRq"};